import Controller from './Controller'
import { trace } from 'rytm-helpers'
import { handleScrollTo } from '../shared/scroll-to'

class HomeController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
  }
  addEventListeners() {
    super.addEventListeners();
    this.checkAndScrollTo();
  }
  removeEventListeners() {
    super.removeEventListeners();
  }
  /**
   * Own..
   */
  checkAndScrollTo() {
    // get all elements with aria-expanded="true"
    const expanded = document.querySelectorAll('[aria-expanded="true"]');
    const lastExpanded = expanded.length > 0 ? expanded[expanded.length - 1] : null;
    if (lastExpanded) {
      setTimeout(() => {
        handleScrollTo(lastExpanded);
      }, 100);
    }
    
  }


}

export default HomeController;